import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListPages from "../Pages/Terms and Conditions/listPages";
import AddPages from "../Pages/Terms and Conditions/addPages";
import EditPages from "../Pages/Terms and Conditions/editPages";
import ViewPages from "../Pages/Terms and Conditions/viewPages";
import SettingsMain from "../Components/Settings/settingsMain";
import FranchiseSidebarConfig from "../Components/Configurations/franchiseSidebarconfig";
// import { getAccessCode } from "../../src/Redux/Actions/pagesActions";

const SettingsRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');


  // if (!isAccessCode) {
  //   return <Navigate to="/pages" replace />;
  // }
  return (
    <Routes>
      <Route path="/pages" element={<ListPages></ListPages>}></Route>
      {/* <Route path="/pages/add" element={<AddPages></AddPages>}></Route> */}
      <Route 
        path="/pages/add" 
        element={canAdd ? <AddPages /> : <Navigate to="/pages" replace />} 
      />
      <Route 
        path="/pages/edit/:id" 
        element={canEdit ? <EditPages /> : <Navigate to="/pages" replace />} 
      />
      <Route path="/pages/view/:type" element={<ViewPages></ViewPages>}></Route>
      <Route path="/settings" element={<SettingsMain></SettingsMain>}></Route>
      <Route path="/franchise_sidebar_sections" element={<FranchiseSidebarConfig />} />
    </Routes>
  );
};

export default SettingsRoutes;
